module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Prologue.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-35"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("PROLOGUE")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic",
    staticStyle: {
      "font-size": "1.76em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("S")]), _vm._v("he awakened with a start, her eyes coming sharply into focus, ears straining toward the odd sound that had pulled her from a deep but restless sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("There.")]), _vm._v(" There it was again, a strange, distant sort of creaking, like one of the floorboards under the carpet in the living room. She shifted on the pillow, trying to hear, but the sound had changed, become a peculiar moaning that sounded like the wind but could not be. Outside the house, the air was hot and still, the summer night densely black and quiet. She listened for the familiar chirp of crickets in the nearby field but they were oddly silent.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The sounds came again, an ominous creak, then a groan unlike anything she had heard in the house before. She sat up in bed, her heart pounding, easing herself slowly back against the headboard, her gaze locked on the door as she tried to decide whether to wake her husband. But Miguel had to go to work early and his days were long and exhausting. Whatever she had heard was surely her imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her ears strained into the silence, listening, listening. But the sound did not come again. She reminded herself to breathe, took a calming breath, and noticed an eerie thickening of the atmosphere in the bedroom. Maria found herself inhaling more deeply, working to suck air into her lungs as if a heavy weight pressed down on her chest. Her heartbeat quickened even more, thudding heavily now, each beat swelling beneath her breastbone.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Madre de Dios, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what is wrong?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She dragged in another labored breath, drawing the thick air into her lungs and slowly forcing it out. She told herself to stay calm. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("It is nothing…only a trick of the mind. Nothing but the hot, moonless night and the silence.")]), _vm._v(" She inhaled again. Out and then in, deep labored breaths that should have steadied her but did nothing to ease her growing fear.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That was when she smelled it. The faint scent of roses. The odor drifted toward her, wrapped itself around her, began to press in on her. It grew as dense as the air, turning thick and heavy, cloying, sickeningly sweet. The fields around the house bloomed with roses nearly half the year, but the scent was soft and light, a pleasing fragrance, nothing at all like the sticky smell that hung in the air: the scent of flowers, which had died and begun to decay.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The bile rose in her throat and Maria whimpered. Her hand shook as she reached for her husband, sleeping peacefully beside her. She paused, knowing once he woke up he would have a hard time returning to sleep, knowing how badly he needed his rest. Still, silently, she willed him to awaken.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her gaze skipped frantically around the room, searching for the source of the noises and the smell, unsure what she might find, but there was nothing there. Nothing that could explain the terror that continued to well inside her, swelling with each frantic beat of her heart.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She swallowed past the fear clogging her throat and reached for Miguel, but just then the rose scent began to fade. The pressure on her chest began to ease and little by little, the air in the room slowly thinned to normal. She took a deep, cleansing breath and released it, then another and another. Outside the window, the familiar chirp of crickets reached her ears and she sagged against the headboard.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was nothing, after all. Just the hot, dry night and her imagination. Miguel would have been angry. He would have accused her of behaving like a child.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Unconsciously her hand came to rest on her stomach. She was no longer a child. She was nineteen years old and carrying a child of her own.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked over at her husband and wished she could sleep as deeply as he. But her eyes remained open, her ears alert. She told herself that she was no longer afraid.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But she knew that for the rest of the night she would not sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-30"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c87056d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prologue.vue
// module id = 69
// module chunks = 0